import React, { FC } from 'react';
import styled from 'styled-components';
import { connectDeep } from '../../../redux-utils';

import App from '../../../models/app';
import ContentGrid from '../AppContentGrid/ContentGrid';
import ItemGrid from '../AppContentGrid/ItemGrid';
import { ContentList, ItemRow } from '../AppContentList/index';
import AppShapedImage from '../AppShapedImage/index';
import { roundEdgeDevices } from '../../../constants';

const AppIcon = styled.img`
  width: 100%;
  max-width: 110px;
  height: auto;
  aspect-ratio: 1 / 1;
  border-radius: 16px;
  object-fit: contain;
  margin-bottom: 12px;
`;

interface AppListProps {
  apps: App[];
  collectionId?: string;
  deviceName: string;
}

const AppListComponent: FC<AppListProps> = ({ apps, collectionId, deviceName }) => {
  if (apps.length === 0) {
    return null;
  }

  // Determine if this flat list contains Tiles or Apps
  const isTile = apps[0].isTile;

  if (isTile) {
    return (
      <ContentList style={{ padding: '16px' }}>
        {apps.map((app) => {
          const queryParam = collectionId ? `?collectionId=${collectionId}` : '';
          const linkTo = `/v2/tile/${app.id}${queryParam}`;

          const photo = (
            <AppShapedImage
              photoProperties={{
                src: app.banners?.[0]?.uri || '',
                alt: app.name,
                width: app.banners?.[0]?.width,
                height: app.banners?.[0]?.height,
                isSquircle: roundEdgeDevices.includes(deviceName?.toLowerCase()),
              }}
              width={90}
              height={90}
              borderRadius="16px"
              borderReservedSpace={false}
            />
          );

          return (
            <ItemRow
              key={app.id}
              id={app.id}
              title={app.name}
              subtitle={
                (app.isTile ? app.isTileInstalled : app.isInstalledOrInstalling)
                  ? 'installed'
                  : undefined
              }
              linkTo={linkTo}
              photo={photo}
            />
          );
        })}
      </ContentList>
    );
  }

  // Render APPs using the grid layout consistent with ItemsPreview.tsx
  return (
    <ContentGrid>
      {apps.map((app) => {
        const queryParam = collectionId ? `?collectionId=${collectionId}` : '';
        const linkTo = `/v2/app/${app.id}${queryParam}`;

        return (
          <ItemGrid
            key={app.id}
            id={app.id}
            title={app.name}
            subtitle={
              (app.isTile ? app.isTileInstalled : app.isInstalledOrInstalling)
                ? 'installed'
                : undefined
            }
            linkTo={linkTo}
            photo={<AppIcon src={app.icon?.uri || ''} alt={app.name} />}
          />
        );
      })}
    </ContentGrid>
  );
};

const mapStateToProps = (state: any) => {
  const deviceName = state.registry.currentUser?.device?.productName || null;
  return {
    deviceName,
  };
};

export const AppList = connectDeep(mapStateToProps)(AppListComponent);

